import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top on every route change, but leaves in-page anchor
// navigations (e.g. `/demo#book-a-walkthrough`) alone so those still jump
// to the correct section.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
